export const processPrismicAds = (events, prismicContent) => {
  // Return original events if no prismic content or events
  if (!events || !Array.isArray(events) || !prismicContent) {
    return events;
  }

  // For event search, we always use 'search' page type
  const prismicContentPage = 'search';

  // Check if prismic content exists for this page type
  if (!prismicContent[prismicContentPage] || !prismicContent[prismicContentPage].length) {
    return events;
  }

  // Create a copy of events to avoid mutating original array
  const eventsWithPrismicContent = [...events];

  // Get ads ordered by index (mirrors legacy logic)
  const ads = prismicContent[prismicContentPage].sort((a, b) => {
    const indexA = a.index || 0;
    const indexB = b.index || 0;
    return indexA - indexB; // ascending order
  });

  // Track ad counts (mirrors legacy counters)
  let eventAds = 0;

  // Process each ad
  ads.forEach((ad) => {
    if (ad.is_active && ad.type === 'events' && eventsWithPrismicContent.length) {
      // Apply same business logic as legacy:
      // - First ad if eventAds < 1
      // - Additional ads if more than 5 events and eventAds >= 1
      if (eventAds < 1 || (eventsWithPrismicContent.length > 5 && eventAds >= 1)) {
        const insertIndex = ad.index ? parseInt(ad.index) - 1 : 0;
        // Ensure insert index is within bounds
        const safeInsertIndex = Math.max(0, Math.min(insertIndex, eventsWithPrismicContent.length));

        eventsWithPrismicContent.splice(safeInsertIndex, 0, {
          ...ad,
          isSponsored: true,
          // Ensure we have a source object for consistency with regular events
          source: ad.source || ad,
        });
        eventAds += 1;
      }
    }
  });

  return eventsWithPrismicContent;
};
